import analytics from '@/locales/en_US/pages/preview/analytics/analytics.en.json'
import analyticsHardening from '@/locales/en_US/pages/preview/analytics/hardening.en.json'
import analyticsPeople from '@/locales/en_US/pages/preview/analytics/people.en.json'
import analyticsSecurity from '@/locales/en_US/pages/preview/analytics/security.en.json'
import assessments from '@/locales/en_US/pages/preview/environments/assessments.en.json'
import environement from '@/locales/en_US/pages/preview/environments/environment.en.json'
import environementNew from '@/locales/en_US/pages/preview/environments/new.en.json'
import schedule from '@/locales/en_US/pages/preview/environments/schedule.en.json'
import environementSettings from '@/locales/en_US/pages/preview/environments/settings.en.json'
import index from '@/locales/en_US/pages/preview/index.en.json'
import diffchanges from '@/locales/en_US/pages/preview/repositories/diffchanges.en.json'
import fixbot from '@/locales/en_US/pages/preview/repositories/fixbot.en.json'
import issueDetails from '@/locales/en_US/pages/preview/repositories/issuedetails.en.json'
import repositoryNew from '@/locales/en_US/pages/preview/repositories/new.en.json'
import repositoryProtection from '@/locales/en_US/pages/preview/repositories/protection.en.json'
import repositoryPullrequests from '@/locales/en_US/pages/preview/repositories/pullrequests.en.json'
import repository from '@/locales/en_US/pages/preview/repositories/repository.en.json'
import repositoryRevisions from '@/locales/en_US/pages/preview/repositories/revisions.en.json'
import repositoryScanOverview from '@/locales/en_US/pages/preview/repositories/scanoverview.en.json'
import repositoryScanReport from '@/locales/en_US/pages/preview/repositories/scanreport.en.json'
import respositorySettings from '@/locales/en_US/pages/preview/repositories/settings.en.json'
import resetPassword from '@/locales/en_US/pages/preview/resetPassword/resetPassword.en.json'
import openAuth from '@/locales/en_US/pages/preview/settings/openAuth.en.json'
import settingsPackages from '@/locales/en_US/pages/preview/settings/packages.en.json'
import settingsPolicies from '@/locales/en_US/pages/preview/settings/policies.en.json'
import settingsReferrals from '@/locales/en_US/pages/preview/settings/referrals.en.json'
import settingsRules from '@/locales/en_US/pages/preview/settings/rules.en.json'
import settingsUpdates from '@/locales/en_US/pages/preview/settings/updates.en.json'
import settingsUsage from '@/locales/en_US/pages/preview/settings/usage.en.json'
import settingsUser from '@/locales/en_US/pages/preview/settings/user.en.json'
import settingsUsers from '@/locales/en_US/pages/preview/settings/users.en.json'
import settingsWorkspace from '@/locales/en_US/pages/preview/settings/workspace.en.json'
import signup from '@/locales/en_US/pages/preview/signup/signup.en.json'
import alert from '@/locales/en_US/shared/alert.en.json'
import drawer from '@/locales/en_US/shared/drawer.en.json'
import modal from '@/locales/en_US/shared/modal.en.json'
import scan from '@/locales/en_US/shared/scan.en.json'
import shared from '@/locales/en_US/shared/shared.en.json'
import slack from '@/locales/en_US/shared/slack.en.json'
import tour from '@/locales/en_US/shared/tour.en.json'
import tree from '@/locales/en_US/shared/tree.en.json'

export const messages = {
  ...analytics,
  ...analyticsHardening,
  ...analyticsPeople,
  ...analyticsSecurity,
  ...assessments,
  ...diffchanges,
  ...drawer,
  ...environement,
  ...environementNew,
  ...environementSettings,
  ...fixbot,
  ...index,
  ...issueDetails,
  ...modal,
  ...openAuth,
  ...repository,
  ...repositoryNew,
  ...repositoryProtection,
  ...repositoryPullrequests,
  ...repositoryRevisions,
  ...repositoryScanOverview,
  ...repositoryScanReport,
  ...resetPassword,
  ...respositorySettings,
  ...scan,
  ...settingsPackages,
  ...settingsPolicies,
  ...settingsReferrals,
  ...settingsRules,
  ...settingsUpdates,
  ...settingsUsage,
  ...settingsUser,
  ...settingsUsers,
  ...settingsWorkspace,
  ...shared,
  ...signup,
  ...slack,
  ...tour,
  ...tree,
  ...schedule,
  ...alert,
}

export default messages
